import {
    ROLE_ADMIN,
    ROLE_ANALYST,
    ROLE_ANALYST_ADMIN
} from "src/components/constants";

import {
    ROUTE_PATH_ADMIN_DASHBOARD,
    ROUTE_PATH_ADMIN_KANBAN_BOARD,
    ROUTE_PATH_ADMIN_BREACH_INCIDENT_REQUEST,
    ROUTE_PATH_ADMIN_DATA_SUBJECT_REQUEST,
    ROUTE_PATH_ADMIN_HARDWARES_LIST,
    ROUTE_PATH_ADMIN_SOFTWARES_LIST,
    ROUTE_PATH_ADMIN_PROCESSING_DIRECTORIES_LIST,
    ROUTE_PATH_ADMIN_LATEST_NEWS_LIST,
    ROUTE_PATH_ADMIN_ADMINISTRATION_SETTINGS,
    ROUTE_PATH_ADMIN_ADMINISTRATION_DEVICE_AGENT,
    ROUTE_PATH_ADMIN_ADMINISTRATION_QUESTIONAIRE,
    ROUTE_PATH_ADMIN_ADMINISTRATION_CUSTOMIZATION,
    ROUTE_PATH_ADMIN_USER_LIST,
    ROUTE_PATH_ADMIN_ADMINISTRATION_HISTORY_LOG,
    ROUTE_PATH_ADMIN_APP_DOCUMENTS,
    ROUTE_PATH_ADMIN_CONTROLS_LIST,
    ROUTE_PATH_ADMIN_DOCUMENTS_LIST,
    ROUTE_PATH_ADMIN_TOMS,
    ROUTE_PATH_ADMIN_OTHER_ASSETS_LIST
} from "src/modules/data-protection/constants"

import {
    ROUTE_PATH_ADMIN_E_LEARNING,
    ROUTE_PATH_ADMIN_TUTORIAL,
    ROUTE_PATH_ADMIN_RISK_MANAGMENT,
    ROUTE_PATH_ADMIN_ENTITY_MANAGMENT,
    ROUTE_PATH_ADMIN_PLATFORM_UPDATE
} from "src/common/constants";

import {
    ROUTE_PATH_EMAIL_INBOX,
} from "src/modules/mailer/constants";

const AdminMenuItems = [
    {
        titleKey    :   "Dashboard",
        path        :   ROUTE_PATH_ADMIN_DASHBOARD,
        icon        :   "ri-home-4-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Kanban Board",
        path        :   ROUTE_PATH_ADMIN_KANBAN_BOARD,
        icon        :   "ri-bar-chart-2-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Incident Register",
        path        :   ROUTE_PATH_ADMIN_BREACH_INCIDENT_REQUEST,
        icon        :   "ri-file-list-3-fill",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Data Subject Request",
        path        :   ROUTE_PATH_ADMIN_DATA_SUBJECT_REQUEST,
        icon        :   "ri-file-list-3-fill",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Asset Register",
        path        :   null,
        icon        :   "ri-computer-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null,
        items: [
            {
                titleKey    :   "Hardware",
                path        :   ROUTE_PATH_ADMIN_HARDWARES_LIST,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Software",
                path        :   ROUTE_PATH_ADMIN_SOFTWARES_LIST,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Other",
                path        :   ROUTE_PATH_ADMIN_OTHER_ASSETS_LIST,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            }
        ]
    },
    {
        titleKey    :   "Processing Directory",
        path        :   ROUTE_PATH_ADMIN_PROCESSING_DIRECTORIES_LIST,
        icon        :   "ri-bar-chart-2-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "TOM",
        path        :   ROUTE_PATH_ADMIN_TOMS,
        icon        :   "ri-file-edit-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Documents",
        path        :   ROUTE_PATH_ADMIN_DOCUMENTS_LIST,
        icon        :   "ri-file-list-2-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [
            ROLE_ANALYST_ADMIN
        ],
        customValidator :   null
    },
    {
        titleKey    :   "Mailbox",
        path        :   ROUTE_PATH_EMAIL_INBOX,
        // Folders/compose/message live under /admin/email/*, not only /inbox
        matchPaths  :   ["/admin/email"],
        icon        :   "ri-mail-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   ['mailer'],
        roles           :   [
            ROLE_ANALYST_ADMIN
        ],
        customValidator :   null
    },
    {
        titleKey    :   "Risk Management",
        path        :   ROUTE_PATH_ADMIN_RISK_MANAGMENT,
        icon        :   "ri-error-warning-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [
            ROLE_ADMIN,
            ROLE_ANALYST,
            ROLE_ANALYST_ADMIN
        ],
        customValidator :   null
    },
    {
        titleKey    :   "Controls",
        path        :   ROUTE_PATH_ADMIN_CONTROLS_LIST,
        // Task details use /admin/data-protection/tasks/*, not /controls/*
        matchPaths  :   ["/admin/data-protection/tasks"],
        icon        :   "ri-checkbox-multiple-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [
            ROLE_ADMIN,
            ROLE_ANALYST,
            ROLE_ANALYST_ADMIN
        ],
        customValidator :   null
    },
    {
        titleKey    :   "Administration",
        path        :   null,
        icon        :   "ri-admin-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null,
        items: [
            {
                titleKey    :   "Questionnaire Designer",
                path        :   ROUTE_PATH_ADMIN_ADMINISTRATION_QUESTIONAIRE,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Settings",
                path        :   ROUTE_PATH_ADMIN_ADMINISTRATION_SETTINGS,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Integration",
                path        :   null,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null,
                items: [
                    {
                        titleKey    :   "Software Sync",
                        path        :   ROUTE_PATH_ADMIN_ADMINISTRATION_DEVICE_AGENT,
                        linkType    :   "react-router",
                        authProtected   :   true,
                        settingKey      :   null,
                        moduleFeatures  :   ['software-fetch'],
                        roles           :   [],
                        customValidator :   null
                    },
                    {
                        titleKey    :   "Email",
                        path        :   ROUTE_PATH_ADMIN_ADMINISTRATION_SETTINGS + "?tab=email-settings",
                        linkType    :   "react-router",
                        authProtected   :   true,
                        settingKey      :   null,
                        moduleFeatures  :   ['mailer'],
                        roles           :   [],
                        customValidator :   null
                    },
                    {
                        titleKey    :   "Confluence",
                        path        :   ROUTE_PATH_ADMIN_ADMINISTRATION_SETTINGS + "?tab=confluence-settings",
                        linkType    :   "react-router",
                        authProtected   :   true,
                        settingKey      :   null,
                        moduleFeatures  :   ['confluence_setting'],
                        roles           :   [],
                        customValidator :   null
                    }
                ]
            },
            {
                titleKey    :   "Customisation",
                path        :   ROUTE_PATH_ADMIN_ADMINISTRATION_CUSTOMIZATION,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Entity Management",
                path        :   ROUTE_PATH_ADMIN_ENTITY_MANAGMENT,
                icon        :   "ri-error-warning-line",
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [
                    'entity_management'
                ],
                roles           :   [
                    ROLE_ADMIN,
                    ROLE_ANALYST_ADMIN
                ],
                customValidator :   null
            },
            {
                titleKey    :   "History logs",
                path        :   ROUTE_PATH_ADMIN_ADMINISTRATION_HISTORY_LOG,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Policies",
                path        :   ROUTE_PATH_ADMIN_APP_DOCUMENTS,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "User Management",
                path        :   ROUTE_PATH_ADMIN_USER_LIST,
                // Shared AD settings route lives under /admin/administration/users/*
                matchPaths  :   [
                    "/admin/administration/users/ad-settings",
                    "/admin/administration/users/add",
                    "/admin/administration/users/:id/edit",
                    "/admin/data-protection/administration/users/add",
                    "/admin/data-protection/administration/users/:id/edit",
                    "/admin/data-protection/administration/users/functions/:key",
                ],
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            },
        ]
    },
    // {
    //     titleKey    :   "E-Learning",
    //     path        :   ROUTE_PATH_ADMIN_E_LEARNING,
    //     icon        :   "ri-video-line",
    //     linkType    :   "react-router",
    //     authProtected   :   true,
    //     settingKey      :   "isElearning",
    //     moduleFeatures  :   [],
    //     roles           :   [],
    //     customValidator :   null
    // },
    {
        titleKey    :   "Tutorial",
        path        :   ROUTE_PATH_ADMIN_TUTORIAL,
        icon        :   "ri-video-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [
            ROLE_ADMIN,
            ROLE_ANALYST_ADMIN
        ],
        customValidator :   null
    },
    {
        titleKey    :   "What’s New",
        path        :   ROUTE_PATH_ADMIN_PLATFORM_UPDATE,
        icon        :   "ri-newspaper-line",
        linkType    :   "react-router",
        moduleFeatures  :   [],
        authProtected   :   true,
        settingKey      :   null,
        roles           :   [
            ROLE_ANALYST_ADMIN
        ],
        customValidator :   null
    }
];

export default AdminMenuItems;